
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuccessIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 121,
  height: 120,
  preserveAspectRatio: "none",
  viewBox: "0 0 1444 1444"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M694.86 150.748c317.83-17.158 589.36 226.661 606.38 544.499 17.02 317.843-226.92 589.263-544.765 606.143-317.65 16.87-588.868-226.88-605.878-544.528C133.588 439.22 377.224 167.895 694.86 150.748zM728.5 1248.95c288.6-1.42 521.48-236.39 520.34-524.993-1.15-288.603-235.89-521.711-524.497-520.841-288.996.871-522.49 236.002-521.341 524.998 1.149 288.996 236.504 522.266 525.498 520.836z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M994.244 540.093c24.206-2.383 42.346 12.162 37.436 37.529-1.53 7.935-8.47 15.227-14.09 21.055-15.91 16.526-33.173 33.388-49.321 49.533L842.682 772.083l-98.084 97.068c-19.747 19.757-39.757 40.416-60.183 59.432-7.859 7.316-16.004 8.381-26.274 7.674-4.888-.336-11.033-5.23-14.578-8.569-24.188-22.79-47.827-46.994-71.329-70.486L453.5 740.14c-6.317-6.167-12.789-12.684-19.529-18.641-13.246-10.926-21.097-36.527-6.358-49.574 28.697-25.404 53.41 7.923 71.568 26.355l39.45 39.523c40.683 40.679 86.568 84.73 125.639 126.366 10.341-12.68 30.494-31.767 42.693-43.981l76.157-76.206a13465.677 13465.677 0 0 1 115.201-114.554c17.309-17.298 80.131-83.526 95.923-89.335z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"121\" height=\"120\" preserveAspectRatio=\"none\"  viewBox=\"0 0 1444 1444\" id=\"c97b0edd-bebb-3c78-a7e4-c93f40c421de\">\r\n  <path d=\"M 694.86 150.748 C 1012.69 133.59 1284.22 377.409 1301.24 695.247 C 1318.26 1013.09 1074.32 1284.51 756.475 1301.39 C 438.825 1318.26 167.607 1074.51 150.597 756.862 C 133.588 439.22 377.224 167.895 694.86 150.748 z M 728.5 1248.95 C 1017.1 1247.53 1249.98 1012.56 1248.84 723.957 C 1247.69 435.354 1012.95 202.246 724.343 203.116 C 435.347 203.987 201.853 439.118 203.002 728.114 C 204.151 1017.11 439.506 1250.38 728.5 1248.95 z\"></path>\r\n  <path fill=\"var(--theme-primary, #810ea9)\" d=\"M 994.244 540.093 C 1018.45 537.71 1036.59 552.255 1031.68 577.622 C 1030.15 585.557 1023.21 592.849 1017.59 598.677 C 1001.68 615.203 984.417 632.065 968.269 648.21 L 842.682 772.083 L 744.598 869.151 C 724.851 888.908 704.841 909.567 684.415 928.583 C 676.556 935.899 668.411 936.964 658.141 936.257 C 653.253 935.921 647.108 931.027 643.563 927.688 C 619.375 904.898 595.736 880.694 572.234 857.202 L 453.5 740.14 C 447.183 733.973 440.711 727.456 433.971 721.499 C 420.725 710.573 412.874 684.972 427.613 671.925 C 456.31 646.521 481.023 679.848 499.181 698.28 L 538.631 737.803 C 579.314 778.482 625.199 822.533 664.27 864.169 C 674.611 851.489 694.764 832.402 706.963 820.188 L 783.12 743.982 C 821.289 705.566 859.691 667.381 898.321 629.428 C 915.63 612.13 978.452 545.902 994.244 540.093 z\"></path>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/success-icon.a150cb8b37e2bed30ea0d2d2961ab929.svg"),
        {
          React: SvgSuccessIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      